import React from 'react';
import { ClipboardAction, useCanvasClipboard } from 'state/canvas-clipboard';
import {
  Balloon,
  Button,
  ClipboardZoneModal,
  Container,
  Icon,
  CutIcon,
} from './style';

import { ReactComponent as CopyIcon } from 'styles/icons/copy-icon.svg';
import { notEmpty } from 'utils/js';

export default function ClipboardZoneIndicator() {
  const modal = React.useRef<any>(null);

  const [nodes] = useCanvasClipboard();

  const [isModalVisible, setModalVisibility] = React.useState(false);

  const action = nodes?.map((node) => node.action)[0];

  const ActionIcon = React.useMemo<any>(() => {
    if (action === ClipboardAction.COPY) {
      return <CopyIcon />;
    }
    if (action === ClipboardAction.CUT) {
      return <CutIcon $isModalVisible={isModalVisible} />;
    }
  }, [action]);

  function showClipboardZoneModal() {
    if (nodes.length) {
      modal.current.show();
      setModalVisibility(true);
    }
  }

  function onModalHide() {
    setModalVisibility(false);
  }

  return (
    <Container>
      <ClipboardZoneModal ref={modal} onHide={onModalHide} />
      <Button
        isVisible={notEmpty(nodes)}
        onClick={showClipboardZoneModal}
        alternativeColorScheme={isModalVisible}>
        <Balloon>{nodes.length}</Balloon>
        <Icon>{ActionIcon}</Icon>
      </Button>
    </Container>
  );
}
